import { useMutation } from '@tanstack/react-query';
import { trackingLinkService } from 'shared/src/api';
import type { PostTrackingLinksAccessLogsRequest } from 'shared/src/api';

export const usePostTrackingLinksAccessLogs = () => {
  return useMutation({
    throwOnError: false,
    mutationFn: (data: PostTrackingLinksAccessLogsRequest) =>
      trackingLinkService.postTrackingLinksAccessLogs(data),
  });
};
